<template>
  <div>
    <BaseForm />
  </div>
</template>

<script>
import BaseForm from 'components/BaseForm';

export default {
  name: 'Job',
  components: {
    BaseForm,
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';
</style>



// WEBPACK FOOTER //
// src/views/Job.vue